export type Quarter = {
  name: string
  start: Date
  /** Exclusive end (first day of the next quarter). */
  end: Date
}

/** Option names are `Qn YYYY` (e.g. `Q3 2026`). */
export function parseQuarterName(name: string): Quarter | null {
  const m = /^Q([1-4]) (\d{4})$/.exec(name)
  if (!m) return null
  const q = Number(m[1])
  const year = Number(m[2])
  const startMonth = (q - 1) * 3
  return {
    name,
    start: new Date(Date.UTC(year, startMonth, 1)),
    end: new Date(Date.UTC(year, startMonth + 3, 1)),
  }
}

export function sortedQuarters(options: string[]): Quarter[] {
  return options
    .map(parseQuarterName)
    .filter((q): q is Quarter => q !== null)
    .sort((a, b) => a.start.getTime() - b.start.getTime())
}
